export default class TaxonDtoLight {
    constructor(obj) {
        this.id = obj[0]
        this.code = obj[0]
        this.latinName = obj[1]
        this.active = obj[2]
        this.status = obj[3]
        this.level = obj[4]
        this.theme = obj[5]
        this.omnidiaCode = obj[6]
        this.omnidiaSynonym = obj[7]
        this.teraOmnidia = obj[8]
        this.spomnidia = obj[9]
        this.refmuseum = obj[10]
        this.aspe = obj[11]
        this.macrophyteCode = obj[12]
        this.worms = obj[13]

        this.labelWithCode = obj[0] ? `${obj[1] || ''} [${obj[0]}]` : (obj[1] || '')
    }
}